module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }]
  }, [_c('span', {
    class: [_vm.prefixSelfClass + '-title']
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('ul', {
    ref: "options"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39277dd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/select/option-group.vue
// module id = 359
// module chunks = 0